module.exports = __webpack_public_path__ + "static/media/Asset 50.4201042b.jpg";